import { render, staticRenderFns } from "./DeliverySummary.vue?vue&type=template&id=68efd225"
import script from "./DeliverySummary.vue?vue&type=script&lang=js"
export * from "./DeliverySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports